import { getLocalAccessToken } from "../../utils/helper";
import api, { handleErrorCreateAndUpdate } from "../../services/api";
import { Toast } from "../../components/notify/Notify";
import { url } from "../../constants/path";
const accessToken = getLocalAccessToken();

api.defaults.headers.common["Authorization"] = "Bearer " + accessToken;

const URL = url.systemDepartment;

export const createDepartment = (data, callback) => {
  api
    .post(URL, data)
    .then((response) => {
      getDepartmentDetail(response.data.data.id, (result) => {
        callback(result);
        Toast("success", "Thành công");
      });
    })
    .catch((err) => {
      // Toast("warning", err.response.data.message);
      handleErrorCreateAndUpdate(err, callback);
    });
};

export const getDepartments = (params = {}, callback) => {
  api
    .get(URL, { params })
    .then((response) => callback(response.data.data))
    .catch((err) => {
      console.log(err);
    });
};

export const getDepartmentDetail = (id, callback) => {
  api
    .get(`${URL}/${id}`)
    .then((response) => callback(response.data.data))
    .catch((err) => {
      console.log(err);
    });
};

export const updateDepartment = (id, data, callback) => {
  api
    .patch(`${URL}/${id}`, data)
    .then((response) => {
      callback(response.data.data);
      Toast("success", "Thành công");
    })
    .catch((err) => {
      // Toast("warning", err.response.data.message);
      handleErrorCreateAndUpdate(err, callback);
    });
};

export const deleteDepartment = (id) => {
  api
    .delete(`${URL}/${id}`)
    .then((response) => Toast("success", "Thành công"))
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};
